// Turns stored registration answers (lower-cased, keyed by label) back into DynamicForm values.

export const toFieldName = (label = '') => label.toLowerCase().replace(/\s+/g, '_');

const norm = (value) => (value ?? '').toString().trim().replace(/\s+/g, ' ').toLowerCase();
const keyNorm = (key) => norm(String(key).replace(/\./g, '_').replace(/\$/g, '__'));

export const valueForLabel = (data, label) => {
  if (!data || !label) return undefined;
  const wanted = keyNorm(label);
  const key = Object.keys(data).find((k) => keyNorm(k) === wanted);
  return key === undefined ? undefined : data[key];
};

const allFields = (fields = []) => fields.flatMap((field) => (field ? [
  field,
  ...(field.optionsWithPricing || []).flatMap((option) => allFields(option?.subFields || [])),
] : []));

export const formInitialValues = (schema = [], data = {}) => {
  const values = {};
  const lists = {};
  allFields(schema).forEach((field) => {
    const raw = valueForLabel(data, field.label);
    if (raw == null || raw === '' || field.type === 'file') return;
    const name = toFieldName(field.label);
    if (field.type === 'list') {
      lists[name] = (Array.isArray(raw) ? raw : [raw]).map(String);
      return;
    }
    const choices = [
      ...(field.optionsWithPricing || []).map((option) => option?.label),
      ...(field.options || []),
    ].filter(Boolean);
    const match = choices.find((label) => norm(label) === norm(raw));
    values[name] = match || (Array.isArray(raw) ? raw.join(', ') : String(raw));
  });
  return { values, lists };
};

const isLocked = (field) => field.type === 'file' || field.type === 'email' || norm(field.label) === 'email';

// Email identifies the attendee and uploads can't be replaced online, so the edit form leaves them out.
export const editableSchema = (fields = []) => fields
  .filter((field) => field && !isLocked(field))
  .map((field) => (field.optionsWithPricing ? {
    ...field,
    optionsWithPricing: field.optionsWithPricing.map((option) => (option?.subFields
      ? { ...option, subFields: editableSchema(option.subFields) }
      : option)),
  } : field));
